import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Alert } from 'reactstrap';
import AppConstants from '../../shared/contants';
import { AuthToken } from '../../shared/user';
import { useUserContext } from '../../shared/user-context';

interface ILoginForm {
    username: string | undefined,
    password: string | undefined
}

const defaultLoginForm: ILoginForm = { username: "", password: "" }

const Login: React.FC<{}> = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";

    const {  logIn, isUserLoggedIn } = useUserContext();
    const [message, setMessage] = useState<string | undefined>();
    const [loginDetail, setLoginDetails] = useState<ILoginForm>(defaultLoginForm);
    const isLoggedIn = isUserLoggedIn();
    
    const doLogin = useCallback((loginForm: ILoginForm) => {    
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', },
            body: JSON.stringify({ username: loginForm.username, password: loginForm.password }),
        };

        fetch(`${AppConstants.API_BASE_URL}/auth`, requestOptions)
            .then((response) => {
                if (response.status === 200) {
                    return response.json()
                } else {
                    throw new Error("incorrect details");
                }
            })
            .then((data: AuthToken) => {
                logIn(data)                               
            }).catch((e: Error) => {
                setMessage(e.message);
                console.log(e.message)
            });        
    }, [logIn])

    useEffect(() => {
        if (isLoggedIn) {            
            //navigate("/", { replace: true });
            navigate(from, { replace: true });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn])

    const signIn = (e: React.FormEvent) => {
        e.preventDefault();
        if ((!loginDetail.username) || (!loginDetail.password)) {
            setMessage("Please fill required fields.")    
            return;        
        }

        doLogin(loginDetail);
    }
    
    const reset = (e: React.FormEvent) => {
        setLoginDetails(defaultLoginForm);
    }

    return (
        <div className="container-fluid">
            <div className="row justify-content-center">
                <div className="col-6">
                    {message && <Alert color="danger">{message}</Alert>}
                    <form method="post" className="row" onSubmit={signIn}>
                        <div className="col-12 mb-3">
                            <label htmlFor="user" className="form-label"></label>
                            <input type="text" className="form-control" id="username" name="username"
                                value={loginDetail?.username}
                                onChange={(e) => setLoginDetails({ ...loginDetail, username: e.target.value })}
                                placeholder="user@example.com">
                            </input>
                        </div>

                        <div className="col-12 mb-3">
                            <label htmlFor="password" className="form-label"></label>
                            <input type="password" className="form-control" id="password" name="password"
                                value={loginDetail?.password}
                                onChange={(e) => setLoginDetails({ ...loginDetail, password: e.target.value })}
                                placeholder="password">
                            </input>
                        </div>

                        <div className="col-12">
                            <div className="d-grid gap-2 d-md-flex justify-content-md-start">
                                <button type="submit" className="btn btn-primary" onClick={signIn}>Sign in</button>
                                <button type="reset" className="btn btn-info" onClick={reset}>Reset</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Login;